<template>
    <div v-if="sortedCharts.length > 0" class="row m-0" style="width: 100%; height: 100%; padding: 10px 0px 0px 0px">
        <div
            class="col-6 boxshadow"
            v-for="(chart, index) in sortedCharts"
            :key="generateUniqueId(chart, index)"
            style="height: 200px"
        >
            <div class="animated-div">
                <template>
                    <div class="chart-title">
                        <div class="status-icon">
                            {{ transName[chart.context.timeDsvn] }}
                        </div>
                        <span> {{ chart.context.fromDate }} ~ </span>
                        <span>{{ chart.context.toDate }}</span>
                    </div>

                    <div class="chart-area">
                        <MixChart
                            :context="{ index: index, timeDsvn: chart.context.timeDsvn }"
                            :chartData="chart.result.data"
                            :options="chart.result.option"
                            :customXAxis="showCurrentAxis(chart.context.timeDsvn)"
                            class="chart"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div v-else class="row m-2 skeleton-grid">
        <div v-for="i in 6" :key="i" class="col-6 p-2 skeleton-box">
            <div class="skeleton-wrapper">
                <div class="skeleton-chart shimmer"></div>
                <div class="skeleton-letter">
                    <div class="skeleton-letter-title shimmer"></div>
                    <div class="skeleton-letter-body shimmer"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import backEndApi from "@src/api/backEndApi";
import { generateColorGradient } from "@views/new/lib/colorGradient";
import MixChart from "@src/components/vue-chartjs/NewMixChart.vue";
import { mapGetters } from "vuex";
export default {
    components: {
        MixChart,
    },
    props: ["title", "pointInfo", "selectedDate", "totalLog"],
    created() {},
    async mounted() {
        let currentCtx = null;
        let nextCtx = this.getNextChartContext(currentCtx);
        let idx = 0;

        while (nextCtx) {
            console.log("넥스트 레벨", nextCtx);
            await this.addNextChart(idx, nextCtx);

            currentCtx = {
                timeDsvn: nextCtx.timeDsvn,
                data: { xValue: nextCtx.toDate },
            };

            idx += 1;
            nextCtx = this.getNextChartContext(currentCtx);
        }
        // await this.addTotalLogChart();

        await this.sortCharts();
    },
    beforDestroy() {},
    data() {
        return {
            charts: [],
            sortedCharts: [],
            orderMap: {
                MONTH: 0,
                QUARTER: 1,
                DAY: 2,
                MIN: 3,
                HOUR: 4,
                RAW: 5,
            },
            transName: {
                MONTH: "월별",
                QUARTER: "15분",
                DAY: "일별",
                MIN: "5분",
                HOUR: "시간별",
                RAW: "수집 데이터",
            },
        };
    },
    computed: {
        ...mapGetters({
            units: "units",
        }),
    },
    watch: {},
    methods: {
        showCurrentAxis(timeDsvn) {
            const showTimeDsvn = ["MONTH", "DAY"];

            if (showTimeDsvn.includes(timeDsvn)) {
                if (timeDsvn === "MONTH") {
                    return moment(this.selectedDate).format("YYYY-MM");
                } else if (timeDsvn === "DAY") {
                    return moment(this.selectedDate).format("YYYY-MM-DD");
                }
            }

            return null;
        },
        fetchTotallog() {},
        async addTotalLogChart() {
            if (!Array.isArray(this.totalLog) || this.totalLog.length === 0) return;

            const context = {
                timeDsvn: "RAW",
                fromDate: moment(this.totalLog[0]?.regDt, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm"),
                toDate: moment(this.totalLog[this.totalLog.length - 1]?.regDt, "YYYYMMDDHHmmss").format(
                    "YYYY-MM-DD HH:mm"
                ),
            };

            const formatted = this.totalLog.map((item) => ({
                regDt: moment(item.regDt, "YYYYMMDDHHmmss").format("YYYY-MM-DD HH:mm"),
                [item.ptAddr]: item.ptVal,
            }));

            const ptAddr = this.totalLog[0]?.ptAddr ?? "unknown";

            const headers = [
                {
                    // ptAddr: ptAddr,
                    ptIdx: ptAddr,
                    ptName: ptAddr,
                    timeDsvn: "minute",
                    unitSmallCode: this.findUnit(this.pointInfo.unitSmallCode),
                },
            ];

            const result = {
                headers,
                results: formatted,
            };

            const chartData = this.makeChartData(result, context);

            this.charts.push({
                context,
                result: chartData[0],
            });
        },
        async sortCharts() {
            const sorted = this.charts.sort(
                (a, b) => this.orderMap[a.context.timeDsvn] - this.orderMap[b.context.timeDsvn]
            );

            const filled = [...sorted];

            while (filled.length < 5) {
                filled.push({ context: {}, result: null });
            }
            // await this.delay(10000);
            this.sortedCharts = filled;
        },
        delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        findUnit(unitSmallCode) {
            return this.units.find((unit) => unit.value == unitSmallCode)?.text ?? "-";
        },
        generateUniqueId(item, index) {
            return `${item.context.ptIdxs}-${index}`;
        },

        getNextChartContext(currentCtx) {
            let nextContext = null;

            if (!currentCtx) {
                const dateFormat = "YYYY-MM";
                const duration = 36; // months
                const toDate = moment();
                const fromDate = moment().subtract(duration, "months");

                nextContext = {
                    timeDsvn: "MONTH",
                    fromDate: fromDate.format(dateFormat),
                    toDate: toDate.format(dateFormat),
                };
                return nextContext;
            }

            if (currentCtx.timeDsvn === "MONTH") {
                const dateFormat = "YYYY-MM-DD";
                const selected = moment(this.selectedDate);

                nextContext = {
                    timeDsvn: "DAY",
                    fromDate: selected.startOf("month").format(dateFormat),
                    toDate: selected.endOf("month").format(dateFormat),
                };
            } else if (currentCtx.timeDsvn === "DAY") {
                const dateFormat = "YYYY-MM-DD HH";
                const base = moment(this.selectedDate);

                nextContext = {
                    timeDsvn: "HOUR",
                    fromDate: base.startOf("day").format(dateFormat),
                    toDate: base.endOf("day").format(dateFormat),
                };
            } else if (currentCtx.timeDsvn === "HOUR") {
                const dateFormat = "YYYY-MM-DD HH:00";
                // const duration = 2;

                const base = moment(this.selectedDate);
                // const now = moment();

                nextContext = {
                    timeDsvn: "QUARTER",
                    // fromDate: base
                    //     .clone()
                    //     .set({
                    //         hour: now
                    //             .clone()
                    //             .subtract(duration, "hours")
                    //             .hour(),
                    //         minute: 0,
                    //         second: 0,
                    //         millisecond: 0,
                    //     })
                    //     .format(dateFormat),
                    // toDate: base
                    //     .clone()
                    //     .set({
                    //         hour: now
                    //             .clone()
                    //             .add(duration, "hours")
                    //             .hour(),
                    //         minute: 0,
                    //         second: 0,
                    //         millisecond: 0,
                    //     })
                    //     .format(dateFormat),
                    fromDate: base.clone().set({ hour: 0 }).format(dateFormat),
                    toDate: base.clone().set({ hour: 23 }).format(dateFormat),
                };
            } else if (currentCtx.timeDsvn === "QUARTER") {
                const dateFormat = "YYYY-MM-DD HH:mm";
                // const duration = 1;

                const base = moment(this.selectedDate);
                // const now = moment();

                nextContext = {
                    timeDsvn: "MIN",
                    // fromDate: base
                    //     .clone()
                    //     .set({
                    //         hour: now
                    //             .clone()
                    //             .subtract(duration, "hours")
                    //             .hour(),
                    //         minute: now
                    //             .clone()
                    //             .subtract(duration, "hours")
                    //             .minute(),
                    //         second: 0,
                    //         millisecond: 0,
                    //     })
                    //     .format(dateFormat),
                    // toDate: base
                    //     .clone()
                    //     .set({
                    //         hour: now
                    //             .clone()
                    //             .add(duration, "hours")
                    //             .hour(),
                    //         minute: now
                    //             .clone()
                    //             .add(duration, "hours")
                    //             .minute(),
                    //         second: 0,
                    //         millisecond: 0,
                    //     })
                    //     .format(dateFormat),
                    fromDate: base.clone().set({ hour: 0, minute: 0 }).format(dateFormat),
                    toDate: base.clone().set({ hour: 23, minute: 59 }).format(dateFormat),
                };
            } else if (currentCtx.timeDsvn === "MIN") {
                const dateFormat = "YYYY-MM-DD HH:mm";

                const base = moment(this.selectedDate);

                nextContext = {
                    timeDsvn: "RAW",

                    fromDate: base.clone().set({ hour: 0, minute: 0 }).format(dateFormat),
                    toDate: base.clone().set({ hour: 23, minute: 59 }).format(dateFormat),
                };
            } else if (currentCtx.timeDsvn === "RAW") {
                return null; // 더 이상 차트가 없으므로 null 반환
            }

            return nextContext;
        },
        async searchTotalLog2(ptIdx, sDt, eDt) {
            return await backEndApi.totalLog
                .searchTotalLog2(ptIdx, sDt, eDt)
                .then((result) => {
                    if (result.status == 200) {
                        return result.data;
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                        return null;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    return null;
                });
        },
        async addNextChart(index, nextContext) {
            let result = null;
            if (nextContext.timeDsvn === "RAW") {
                result = await this.searchTotalLog2(this.pointInfo.ptAddr, nextContext.fromDate, nextContext.toDate);
            } else {
                result = await this.getTrendData(nextContext);
            }
            const chartData = this.makeChartData(result, nextContext);

            if (index == this.charts.length) {
                const newChart = {
                    context: nextContext,
                    result: chartData[0],
                };
                this.charts.push(newChart);
            } else {
                // index 차트 데이터를 갱신
                this.charts[index].context = nextContext;
                this.charts[index].result = chartData[0];
            }

            // 반응형 데이터 변경
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        async getTrendData(chartContext) {
            try {
                chartContext.ptIdxs = this.pointInfo.ptIdx;

                let result = await backEndApi.dataAnalysis.fetchSummaryData2(chartContext);
                if (result.status == 200) {
                    return result.data;
                } else {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (err) {
                console.error(err);
            }
        },
        formatResultDatetime(timeDsvn, isoDate) {
            const date = new Date(isoDate);

            if (timeDsvn == "YEAR") {
                return date.format("yyyy");
            } else if (timeDsvn == "MONTH") {
                return date.format("yyyy-MM");
            } else if (timeDsvn == "DAY") {
                return date.format("MM-dd");
            } else if (timeDsvn == "HOUR") {
                return date.format("MM-dd HH:mm");
            } else {
                return date.format("MM-dd HH:mm");
            }
        },

        makeChartData(baseData, nextContext) {
            const charts = [];
            // const that = this;
            const headers = baseData?.headers;
            // const results = baseData.results;

            let results;

            if (nextContext.timeDsvn == "QUARTER") {
                results = baseData.results.filter((result) => {
                    const reg = moment(result.regDt).format("YYYY-MM-DD HH:mm");
                    return reg >= nextContext.fromDate && reg <= nextContext.toDate;
                });
            } else if (nextContext.timeDsvn == "MIN") {
                results = baseData.results.filter((result) => {
                    const reg = moment(result.regDt).format("YYYY-MM-DD HH:mm");
                    return reg >= nextContext.fromDate && reg <= nextContext.toDate;
                });
            } else {
                results = baseData?.results;
            }

            const startColor = "#000000";
            const endColor = "#0000FF";
            let backgroundColors = [];
            if (headers?.length > 1) {
                backgroundColors = generateColorGradient(startColor, endColor, headers.length - 1);
            } else {
                backgroundColors[0] = "#A0A0A0";
            }

            headers?.forEach((header, headerIndex) => {
                const backgroundColor = backgroundColors[headerIndex]; // 단일 색상

                // const unit = this.units.find((unit) => unit.value == header.unitSmallCode)?.text ?? "-";
                const unit = this.findUnit(header.unitSmallCode);

                const borderColor = backgroundColor + "99";
                const dispText = header.ptName ?? header.ptAddr;

                // 시간축(xAxis) 표시용 설정
                const displayFormats = {
                    millisecond: "MM-DD HH:mm:ss.SSS",
                    second: "MM-DD HH:mm:ss",
                    minute: "HH:mm",
                    hour: " HH:mm",
                    day: "MM-DD",
                    week: "YYYY-MM-DD",
                    month: "YYYY-MM",
                    quarter: "YYYY [Q]Q",
                    year: "YYYY",
                };

                let timeUnit = "";

                if (header.timeDsvn == "MONTH") {
                    timeUnit = "month";
                } else if (header.timeDsvn == "DAY") {
                    timeUnit = "day";
                } else if (header.timeDsvn == "HOUR") {
                    timeUnit = "hour";
                } else {
                    timeUnit = "minute";
                }

                charts.push({
                    key: `${header.ptAddr}`,
                    flag: true,
                    data: {
                        labels: results.map((result) => result.regDt),
                        datasets: [
                            {
                                key: dispText,
                                propCode: dispText,
                                type: "line",
                                lineTension: 0.5,
                                borderWidth: 1.3,
                                fill: true,
                                label: dispText + ` (${unit})`,
                                pointRadius: 1,
                                showLine: true,
                                interpolate: true,
                                spanGaps: true, // 누락된 데이터 연결 옵션
                                borderColor,
                                backgroundColor: backgroundColor + "44",
                                data: results.map((result) => {
                                    if (nextContext.timeDsvn === "RAW") {
                                        return result.ptValRaw ?? null;
                                    } else {
                                        return result[header.ptIdx] ?? null;
                                    }
                                }),
                            },
                        ],
                    },
                    option: {
                        responsive: true,
                        maintainAspectRatio: false,
                        animation: {
                            duration: 1000,
                            easing: "easeOutQuart",
                        },
                        legend: {
                            display: true,
                            align: "end",
                            labels: {
                                boxWidth: 12,
                                fontColor: backgroundColor + "FF",
                                fontSize: 10,
                            },
                        },
                        title: {
                            display: false,
                            align: "start",
                            position: "top",
                            text: dispText,
                            fontSize: 12,
                            fontColor: "#000000",
                        },
                        layout: { padding: { left: 0, right: 0, top: 0, bottom: 0 } },
                        hover: {
                            mode: "index",
                            intersect: true,
                            animationDuration: 400,
                        },
                        elements: {
                            point: {
                                hitRadius: 25, // 포인트 클릭 반경 조절
                            },
                        },
                        tooltips: {
                            mode: "index",
                            intersect: false,
                            titleFontSize: 10,
                            bodyFontSize: 11,
                            enabled: false,
                            custom: function (tooltipModel) {
                                let bodyEmptyCheck = false;

                                var tooltipEl = document.getElementById("chartjs-tooltip");

                                if (!tooltipEl) {
                                    tooltipEl = document.createElement("div");
                                    tooltipEl.id = "chartjs-tooltip";
                                    tooltipEl.innerHTML = "<table></table>";
                                    document.body.appendChild(tooltipEl);
                                }

                                if (tooltipModel.opacity === 0) {
                                    tooltipEl.style.opacity = 0;
                                    return;
                                }

                                if (tooltipModel.body) {
                                    let NOTNULLValue = tooltipModel.body.find((v) =>
                                        v.lines.find((t) => !t.includes("null"))
                                    );
                                    if (!NOTNULLValue) {
                                        bodyEmptyCheck = true;
                                    }
                                }

                                if (bodyEmptyCheck) {
                                    tooltipEl.style.opacity = 0;
                                    return;
                                }

                                // 스타일 설정
                                tooltipEl.style.backgroundColor = "rgba(0, 0, 0, 0.7)"; // 배경색 설정
                                tooltipEl.style.color = "#fff"; // 글자색 설정
                                tooltipEl.style.paddingTop = "4px"; // 패딩 설정
                                tooltipEl.style.paddingBottom = "4px"; // 패딩 설정
                                tooltipEl.style.paddingLeft = "8px"; // 패딩 설정
                                tooltipEl.style.paddingRight = "8px"; // 패딩 설정
                                tooltipEl.style.borderColor = tooltipModel.borderColor;
                                tooltipEl.style.borderWidth = tooltipModel.borderWidth + "px";
                                tooltipEl.style.borderRadius = tooltipModel.cornerRadius + "px";
                                tooltipEl.style.borderStyle = "solid";
                                tooltipEl.style.position = "absolute";
                                tooltipEl.style.pointerEvents = "none";
                                tooltipEl.style.zIndex = "9999";
                                tooltipEl.style.opacity = 0.8; // 투명도 설정

                                if (tooltipModel.body) {
                                    let titleLines = tooltipModel.title || [];
                                    let bodyLines = tooltipModel.body.map((item) => item.lines);

                                    let innerHtml = "<thead>";

                                    titleLines.forEach(function (title) {
                                        innerHtml += '<tr><th style="color: #FFAB00;">' + title + "</th></tr>"; // x라벨 색상
                                    });
                                    innerHtml += "</thead><tbody>";

                                    bodyLines.forEach(function (body, i) {
                                        let colors = tooltipModel.labelColors[i];
                                        let style = "background:" + colors.backgroundColor;
                                        style += "; border-color:" + colors.borderColor;
                                        style += "; border-width: 2px";
                                        style += "; width: 10px";
                                        style += "; height: 10px";
                                        style += "; font-size: 10px";
                                        style += "; align-self: center";
                                        style += "; margin-right: 2px";
                                        let span = '<div style="' + style + '"></div>';
                                        innerHtml +=
                                            '<tr><td style="display:flex; color: #A7FFEB;">' +
                                            span +
                                            body +
                                            "</td></tr>"; // 값 색상
                                    });
                                    innerHtml += "</tbody>";

                                    let tableRoot = tooltipEl.querySelector("table");
                                    tableRoot.innerHTML = innerHtml;
                                }

                                let position = this._chart.canvas.getBoundingClientRect();
                                let xOffset = 20; // 추가된 x 옵셋
                                tooltipEl.style.left =
                                    position.left + window.pageXOffset + tooltipModel.caretX + xOffset + "px";
                                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + "px";
                                tooltipEl.style.opacity = 1;
                            },
                            callbacks: {
                                label: (tooltipItems, data) => {
                                    // let unit = that.findUnit(this.unitSmallCode);
                                    let value = data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
                                    value = value !== undefined ? value.toLocaleString() : "No data"; // 데이터가 없을 경우 처리
                                    let style = "color: #A7FFEB";
                                    style += "; margin-right: 4px";
                                    style += "; font-size: 12px";
                                    style += "; font-weight: 700";
                                    style += "; align-self: center";

                                    return unit != "-"
                                        ? `<span style="${style}">${value}</span><span style="color: #EEEEEE;">${unit}</span>`
                                        : `<span style="${style}">${value}</span>`; // 단위 색상
                                },
                            },
                        },
                        scales: {
                            xAxes: [
                                {
                                    id: "x-axis-0",
                                    type: "time",
                                    time: {
                                        unit: timeUnit,
                                        tooltipFormat: displayFormats[timeUnit],
                                        displayFormats: {
                                            [timeUnit]: displayFormats[timeUnit],
                                        },
                                    },
                                    stacked: false,
                                    offset: true,
                                    ticks: {
                                        maxTicksLimit: 10,
                                        autoSkip: true,
                                        fontColor: "#000000",
                                        fontSize: 10,
                                        maxRotation: 0,
                                    },
                                    gridLines: {
                                        display: true,
                                        color: backgroundColor + "44",
                                        borderDash: [2, 1],
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    id: "y-axis-0",
                                    display: true,
                                    position: "left",
                                    stacked: false,
                                    ticks: {
                                        maxTicksLimit: 5,
                                        beginAtZero: true,
                                        fontColor: "#000000",
                                        fontSize: 10,
                                    },
                                    gridLines: {
                                        display: true,
                                        color: backgroundColor + "44",
                                        borderDash: [2, 1],
                                    },
                                },
                            ],
                        },
                        plugins: {
                            zoom: {
                                pan: {
                                    enabled: true,
                                    mode: "xy",
                                },
                                zoom: {
                                    enabled: true,
                                    drag: true,
                                    mode: "xy",
                                },
                            },
                        },
                    },
                });
            });

            return charts;
        },
    },
};
</script>

<style scoped>
.boxshadow {
}
.animated-div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    /* 차트 영역을 고려한 높이 설정 */
    /* margin: 10px 0; */
    background-color: #f1f1f1;
    overflow: hidden;
    /* cursor: pointer; */
    position: relative;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}
.chart-title {
    height: 100%;
    width: 200px;
    flex-grow: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* transition: flex-grow 0.3s ease; */

    /* background-color: #ececec; */
    background-color: #f1f1f1;

    padding: 8px 16px 8px 16px;
    margin-bottom: 0px !important;
    font-weight: bold;
    /* display: flex; */
    /* margin-top: 10px; */

    border-radius: 6px 6px 0px 0px;
    border: solid #ececec 1px;
    border-bottom: 1px solid #ccc;
}
.chart-area {
    width: 100%;
    height: 100%;
    max-height: 80vh;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 15px;
    overflow: auto;

    /* border-top: 1px solid #ccc; */
    border-radius: 0px 0px 6px 6px;
    border: solid #ececec 1px;
}

.chart {
    width: 100%;
    height: 100%;
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    height: 0;
}
.status-icon {
    font-size: 12px;
    width: 100%;
    color: white;
    background-color: #3c5b6f;
    border: solid #3c5b6f 1px;
    /* background-color: #FF6D00;
    border: solid #FF6D00 1px; */
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.05rem;
    margin-bottom: 1rem;
    /* width: 4rem; */
    height: 1.8rem;
}
.skeleton-box {
    display: flex;
    justify-content: center;
}
.skeleton-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 98%;
    height: 80%;
    background-color: #f9f9f9;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid #ececec;
}
.skeleton-letter {
    width: 100%;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}
.skeleton-chart {
    width: 100%;
    height: 120px;
    border-radius: 4px;
    margin-bottom: 16px;
    background-color: #e0e0e0;
}
.skeleton-letter-title {
    width: 80%;
    height: 20px;
    margin-bottom: 16px;
    border-radius: 4px;
    background-color: #e0e0e0;
}
.skeleton-letter-body {
    width: 60%;
    height: 20px;
    margin-bottom: 16px;
    border-radius: 4px;
    background-color: #e0e0e0;
}

.shimmer {
    position: relative;
    overflow: hidden;
}

.shimmer::after {
    content: "";
    position: absolute;
    top: 0;
    left: -150px;
    width: 150px;
    height: 100%;
    background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.6) 50%,
        rgba(255, 255, 255, 0) 100%
    );
    animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
    100% {
        transform: translateX(100%);
    }
}
.skeleton-grid {
    width: 100%;
    padding: 0 10px;
}

.skeleton-wrapper {
    min-height: 180px;
}
</style>
